<template>
  <div id="billing_invoice-history" class="mb-8">
    <div class="card tile">
      <div class="card-header border-bottom rounded-0">
        <h3 class="card-text">
          <span>{{ trans('dashboard.account.billing.invoice_history.title') }}</span>
        </h3>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table aria-label="Invoice History" class="table">
            <thead>
            <tr>
              <th scope="col">{{ trans('dashboard.account.billing.invoice_history.invoice_number') }}</th>
              <th scope="col">{{ trans('common.date') }}</th>
              <th v-if="showDescription" scope="col">{{ trans('common.description') }}</th>
              <th class="text-right" scope="col">{{ trans('common.total') }}</th>
              <th v-if="!hideAction" class="text-right" scope="col">{{ trans('common.actions') }}</th>
            </tr>
            </thead>
            <tbody v-if="invoiceCount > 0">
            <tr v-for="invoice in invoices">
              <!-- Invoice Number -->
              <td>
                <strong>#{{ invoice.number }}</strong>
              </td>

              <!-- Invoice Date -->
              <td>
                <strong>{{ invoice.created_at }}</strong>
              </td>

              <!-- Description -->
              <td v-if="showDescription">
                <strong>{{ invoice.description }}</strong>
              </td>

              <td class="text-right">
                {{ invoice.total }}
              </td>

              <td v-if="!hideAction" class="text-right">
                <a :href="$route('dashboard.account.billing.invoices.download', invoice.id)" class="button">
                  <em class="fa fa-btn fa-file-pdf-o mr-1"></em> {{ trans('common.download') }}
                </a>
              </td>
            </tr>
            <tr v-if="ticket">
              <td colspan="5" style="text-align: right;">
                <a :href="getUserInvoiceUrl" target="_blank">See the full list</a>
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="5">{{ trans('dashboard.account.billing.invoice_history.no_invoices') }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BillingInvoiceHistory',

  props: {
    invoices: Array,
    ticket: Object,
    hideAction: Boolean,
    showDescription: Boolean,
  },
  computed: {
    getUserInvoiceUrl() {
      return "/nova/resources/users/"
        + this.ticket.user.id
        + "#User Details: "
        + this.ticket.user.name
        + "=orders";
    },
    invoiceCount() {
      return this.invoices.length;
    },
  }
};
</script>
